// Offer announcement: copies the discount code to the clipboard.
//
// Uses the async Clipboard API where available and falls back to a hidden
// textarea + execCommand for older browsers and non-secure contexts, where
// navigator.clipboard is undefined.

function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }

  return new Promise(function (resolve, reject) {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-9999px';
    document.body.appendChild(area);
    area.select();

    try {
      const ok = document.execCommand('copy');
      document.body.removeChild(area);
      ok ? resolve() : reject(new Error('copy command failed'));
    } catch (err) {
      document.body.removeChild(area);
      reject(err);
    }
  });
}

function initOfferCopy(button) {
  if (button.dataset.offerCopyInit) return;
  button.dataset.offerCopyInit = '1';

  const label = button.querySelector('[data-offer-copy-label]');
  const original = button.dataset.label || (label && label.textContent) || '';
  const copied = button.dataset.labelCopied || 'Copied!';
  let timer = null;

  button.addEventListener('click', function () {
    copyText(button.dataset.code || '')
      .then(function () {
        button.classList.add('is-copied');
        if (label) label.textContent = copied;

        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          button.classList.remove('is-copied');
          if (label) label.textContent = original;
        }, 2000);
      })
      .catch(function () {
        // Leave the button untouched so the code stays visible to copy by hand.
      });
  });
}

function bootOfferCopy(scope) {
  (scope || document).querySelectorAll('[data-offer-copy]').forEach(initOfferCopy);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootOfferCopy();
  });
} else {
  bootOfferCopy();
}

document.addEventListener('shopify:section:load', function (e) {
  bootOfferCopy(e.target);
});
